import L from "leaflet";
import "leaflet/dist/leaflet.css";

const mapElement = document.getElementById("mapid");
if (mapElement) {
  const lat = parseFloat(mapElement.getAttribute("data-latitude"));
  const lng = parseFloat(mapElement.getAttribute("data-longitude"));
  const zoom = parseInt(mapElement.getAttribute("data-zoom"));

  var pin = L.icon({
    iconUrl:
      "https://aftercoal.pl/wp-content/themes/lifeaftercoal/assets/img/map-pin.svg",
    iconSize: [25, 25],
    iconAnchor: [12, 25],
  });

  var map = L.map("mapid").setView([lat, lng], zoom);

  L.marker([lat, lng], { icon: pin }).addTo(map);
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    className: "bw",
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  }).addTo(map);
}
